import { TFunction } from 'i18next';

import { IntroAnimationVariant } from '~/modules/feature-access/components/IntroAnimation/types';

import DetectorHighlightsAnimationSrc from '../../assets/detector_highlights.riv';
import DetectorReportAnimationSrc from '../../assets/detector_report.riv';
import ParaphraseOutputAnimationSrc from '../../assets/paraphraser_output.riv';
import ParaphraseToneAnimationSrc from '../../assets/paraphraser_tone.riv';

export const introAnimationData: Record<
  IntroAnimationVariant,
  {
    src: string;
    getTexts: (t: TFunction) => { runName: string; text: string }[];
  }
> = {
  [IntroAnimationVariant.DETECTOR_HIGHLIGHTS]: {
    src: DetectorHighlightsAnimationSrc,
    getTexts: (t) => [
      {
        runName: 'scanning',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[0]',
          'Scanning',
        ),
      },
      {
        runName: 'AIScore',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[1]',
          '100% Human Written',
        ),
      },
      {
        runName: 'RegularTextMain',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[2]',
          '"To Kill a Mockingbird" is a classic novel set in the American South during the 1930s, narrated by a young girl named Scout Finch',
        ),
      },
      {
        runName: 'AIMain',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[3]',
          'The story centers on Scout and her brother Jem as their father, Atticus Finch, defends a Black man falsely accused of assaulting a white woman',
        ),
      },
      {
        runName: 'Part1',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[4]',
          'The story',
        ),
      },
      {
        runName: 'Part2',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[5]',
          'follows Scout and her brother',
        ),
      },
      {
        runName: 'Part3',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[6]',
          'Jem as their father, ',
        ),
      },
      {
        runName: 'Part4',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[7]',
          'Atticus Finch, defends',
        ),
      },
      {
        runName: 'Part5',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[8]',
          'black man accused',
        ),
      },
      {
        runName: 'Part6',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[9]',
          'of raping a white woman',
        ),
      },
      {
        runName: 'RegularTextMain2',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[10]',
          'The novel explores themes of racial injustice, moral growth, and empathy.',
        ),
      },
      {
        runName: 'RegularTextBot2',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[2]',
          '"To Kill a Mockingbird" is a classic novel set in the American South during the 1930s, narrated by a young girl named Scout Finch.',
        ),
      },
      {
        runName: 'AIBot2',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[3]',
          'The story centers on Scout and her brother Jem as their father, Atticus Finch, defends a Black man falsely accused of assaulting a white woman.',
        ),
      },
      {
        runName: 'RegularText2Bot2',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[10]',
          'The novel explores themes of racial injustice, moral growth, and empathy.',
        ),
      },
      {
        runName: 'RegularTextTop2',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[2]',
          '"To Kill a Mockingbird" is a classic novel set in the American South during the 1930s, narrated by a young girl named Scout Finch.',
        ),
      },
      {
        runName: 'AITop2',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[3]',
          'The story centers on Scout and her brother Jem as their father, Atticus Finch, defends a Black man falsely accused of assaulting a white woman.',
        ),
      },
      {
        runName: 'RegularText2Top2',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[10]',
          'The novel explores themes of racial injustice, moral growth, and empathy.',
        ),
      },
      {
        runName: 'RegularTextTop',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[2]',
          '"To Kill a Mockingbird" is a classic novel set in the American South during the 1930s, narrated by a young girl named Scout Finch.',
        ),
      },
      {
        runName: 'AITop',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[3]',
          'The story centers on Scout and her brother Jem as their father, Atticus Finch, defends a Black man falsely accused of assaulting a white woman.',
        ),
      },
      {
        runName: 'RegularText2Top',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[10]',
          'The novel explores themes of racial injustice, moral growth, and empathy.',
        ),
      },
      {
        runName: 'RegularTextBot',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[2]',
          '"To Kill a Mockingbird" is a classic novel set in the American South during the 1930s, narrated by a young girl named Scout Finch.',
        ),
      },
      {
        runName: 'AIBot',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[3]',
          'The story centers on Scout and her brother Jem as their father, Atticus Finch, defends a Black man falsely accused of assaulting a white woman.',
        ),
      },
      {
        runName: 'RegularText2Bot',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[10]',
          'The novel explores themes of racial injustice, moral growth, and empathy.',
        ),
      },
      {
        runName: 'RegularTextMid2',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[2]',
          '"To Kill a Mockingbird" is a classic novel set in the American South during the 1930s, narrated by a young girl named Scout Finch.',
        ),
      },
      {
        runName: 'AIMid2',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[3]',
          'The story centers on Scout and her brother Jem as their father, Atticus Finch, defends a Black man falsely accused of assaulting a white woman.',
        ),
      },
      {
        runName: 'RegularText2Mid2',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[10]',
          'The novel explores themes of racial injustice, moral growth, and empathy.',
        ),
      },
      {
        runName: 'RegularTextMid',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[2]',
          '"To Kill a Mockingbird" is a classic novel set in the American South during the 1930s, narrated by a young girl named Scout Finch.',
        ),
      },
      {
        runName: 'AIMid',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[3]',
          'The story centers on Scout and her brother Jem as their father, Atticus Finch, defends a Black man falsely accused of assaulting a white woman.',
        ),
      },
      {
        runName: 'RegularText2Mid',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[10]',
          'The novel explores themes of racial injustice, moral growth, and empathy.',
        ),
      },
    ],
  },
  [IntroAnimationVariant.DETECTOR_REPORT]: {
    src: DetectorReportAnimationSrc,
    getTexts: (t) => [
      {
        runName: 'HumanWritten',
        text: t(
          'modal:feature_unlock.detector_report_animation_text[0]',
          'Human Written',
        ),
      },
    ],
  },
  [IntroAnimationVariant.PARAPHRASE_OUTPUT]: {
    src: ParaphraseOutputAnimationSrc,
    getTexts: (t) => [
      {
        runName: 'Click',
        text: t(
          'modal:feature_unlock.paraphraser_output_animation_text[0]',
          'Click',
        ),
      },
      {
        runName: 'UpTo5Variants',
        text: t(
          'modal:feature_unlock.paraphraser_output_animation_text[1]',
          'Up To 5 Variants',
        ),
      },
    ],
  },
  [IntroAnimationVariant.PARAPHRASE_TONE]: {
    src: ParaphraseToneAnimationSrc,
    getTexts: (t) => [
      {
        runName: 'DescriptionNeutral',
        text: t(
          'modal:feature_unlock.paraphraser_tone_animation_text[0]',
          "Your brain uses more energy when you're asleep than when you're awake",
        ),
      },
      {
        runName: 'DescriptionInformative',
        text: t(
          'modal:feature_unlock.paraphraser_tone_animation_text[0]',
          "Your brain uses more energy when you're asleep than when you're awake",
        ),
      },
      {
        runName: 'DescriptionCustom',
        text: t(
          'modal:feature_unlock.paraphraser_tone_animation_text[1]',
          'Even in rest, your brain is hard at work—proof that growth and healing happen when you pause',
        ),
      },
      {
        runName: 'DescriptionPersuasive',
        text: t(
          'modal:feature_unlock.paraphraser_tone_animation_text[2]',
          'Think sleep is lazy time? Think again—your brain uses more energy at night, so quality rest is essential for top performance',
        ),
      },
      {
        runName: 'DescriptionProfessional',
        text: t(
          'modal:feature_unlock.paraphraser_tone_animation_text[3]',
          'Neurological studies indicate that the brain’s energy expenditure increases during sleep, primarily due to critical cognitive and physiological processes',
        ),
      },
      {
        runName: 'DescriptionInspirational',
        text: t(
          'modal:feature_unlock.paraphraser_tone_animation_text[1]',
          'Even in rest, your brain is hard at work—proof that growth and healing happen when you pause',
        ),
      },
      {
        runName: 'DescriptionCasual',
        text: t(
          'modal:feature_unlock.paraphraser_tone_animation_text[4]',
          'Weird but true — your brain works harder when you’re asleep than when you’re awake!',
        ),
      },
      {
        runName: 'Neutral1',
        text: t(
          'modal:feature_unlock.paraphraser_tone_animation_text[5]',
          'Neutral',
        ),
      },
      {
        runName: 'Neutral2',
        text: t(
          'modal:feature_unlock.paraphraser_tone_animation_text[5]',
          'Neutral',
        ),
      },
      {
        runName: 'Casual1',
        text: t(
          'modal:feature_unlock.paraphraser_tone_animation_text[6]',
          'Casual',
        ),
      },
      {
        runName: 'Casual2',
        text: t(
          'modal:feature_unlock.paraphraser_tone_animation_text[6]',
          'Casual',
        ),
      },
      {
        runName: 'Informative1',
        text: t(
          'modal:feature_unlock.paraphraser_tone_animation_text[7]',
          'Informative',
        ),
      },
      {
        runName: 'Informative2',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[7]',
          'Informative',
        ),
      },
      {
        runName: 'Custom',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[8]',
          'Custom',
        ),
      },
      {
        runName: 'Persuasive',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[9]',
          'Persuasive',
        ),
      },
      {
        runName: 'Professional',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[10]',
          'Professional',
        ),
      },
      {
        runName: 'Explanatory',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[11]',
          'Explanatory',
        ),
      },
      {
        runName: 'Critical',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[12]',
          'Critical',
        ),
      },
      {
        runName: 'Reassuring',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[13]',
          'Reassuring',
        ),
      },
      {
        runName: 'Youthful',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[14]',
          'Youthful',
        ),
      },
      {
        runName: 'Mystical',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[15]',
          'Mystical',
        ),
      },
      {
        runName: 'Empathetic',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[16]',
          'Empathetic',
        ),
      },
      {
        runName: 'Authoritative',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[17]',
          'Authoritative',
        ),
      },
      {
        runName: 'Sarcastic',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[18]',
          'Sarcastic',
        ),
      },
      {
        runName: 'Analytical',
        text: t(
          'modal:feature_unlock.detector_highlights_animation_text[19]',
          'Analytical',
        ),
      },
    ],
  },
};
